/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArtifactReasoningContent } from './ArtifactReasoningContent';
import {
    ArtifactReasoningContentFromJSON,
    ArtifactReasoningContentFromJSONTyped,
    ArtifactReasoningContentToJSON,
    ArtifactReasoningContentToJSONTyped,
} from './ArtifactReasoningContent';

/**
 * 
 * @export
 * @interface ArtifactReasoning
 */
export interface ArtifactReasoning {
    /**
     * 
     * @type {string}
     * @memberof ArtifactReasoning
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactReasoning
     */
    messageId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArtifactReasoning
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactReasoning
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactReasoning
     */
    kind: ArtifactReasoningKindEnum;
    /**
     * 
     * @type {ArtifactReasoningContent}
     * @memberof ArtifactReasoning
     */
    content: ArtifactReasoningContent;
}


/**
 * @export
 */
export const ArtifactReasoningKindEnum = {
    Reasoning: 'reasoning'
} as const;
export type ArtifactReasoningKindEnum = typeof ArtifactReasoningKindEnum[keyof typeof ArtifactReasoningKindEnum];


/**
 * Check if a given object implements the ArtifactReasoning interface.
 */
export function instanceOfArtifactReasoning(value: object): value is ArtifactReasoning {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('messageId' in value) || value['messageId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ArtifactReasoningFromJSON(json: any): ArtifactReasoning {
    return ArtifactReasoningFromJSONTyped(json, false);
}

export function ArtifactReasoningFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtifactReasoning {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'messageId': json['messageId'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'kind': json['kind'],
        'content': ArtifactReasoningContentFromJSON(json['content']),
    };
}

export function ArtifactReasoningToJSON(json: any): ArtifactReasoning {
    return ArtifactReasoningToJSONTyped(json, false);
}

export function ArtifactReasoningToJSONTyped(value?: ArtifactReasoning | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'messageId': value['messageId'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'kind': value['kind'],
        'content': ArtifactReasoningContentToJSON(value['content']),
    };
}

